// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3-4Vk","label":"Radio_label__33SqT","checkMark":"Radio_checkMark__1IEwS","disabled":"Radio_disabled__3TiDG"};